<script setup lang="ts">
import { computed, onMounted, type PropType } from 'vue'
import { useToast, VIcons, type VToastItem, VToastTypes } from '@/shared/ui'

const props = defineProps({
  item: {
    type: Object as PropType<VToastItem>,
    required: true,
  },
})

const toast = useToast()

/* Вычисляем данные в зависимости от типа */
const toastOptions = computed(() => {
  switch (props.item?.type) {
    case VToastTypes.WARNING:
      return {
        icon: 'error',
        class: 'v-toast-item__warning',
      }
    case VToastTypes.ERROR:
      return {
        icon: 'cancel',
        class: 'v-toast-item__error',
      }
    default:
      return {
        icon: 'check_circle',
        class: '',
      }
  }
})

let timeOutId = 0

onMounted(() => {
  if (!props.item) return

  /* Удаляем элемент после окончания lifeTime */
  if (props.item.lifeTime) {
    timeOutId = setTimeout(() => toast.remove(props.item.id), props.item.lifeTime * 1000)
  }

  /* Вызываем звуковое оповещение */
  if (toast.isAudio) {
    toast.playAudio()
  }
})

/**
 * Удаляем элемент и очищаем интервал
 */
const closeHandler = () => {
  toast.remove(props.item.id)

  clearTimeout(timeOutId)
}
</script>

<template>
  <div class="v-toast-item" :class="toastOptions.class" @click="closeHandler">
    <div class="v-toast-item__data">
      <div class="v-toast-item__title">
        <VIcons :type="toastOptions.icon" />

        <RouterLink
          v-if="item.link"
          :to="item.link"
          v-html="item.title || $t('itf.system_message')"
        />

        <span v-html="item.title || $t('itf.system_message')" v-else></span>
      </div>

      <div class="v-toast-item__content" v-html="item.content"></div>
    </div>

    <div class="v-toast-item__close" @click="closeHandler">
      <VIcons type="close" />
    </div>
  </div>
</template>
